import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { AmazonAddressBook, bootstrapWithAmazon, WalletWidget } from 'amazon-pay-react';
import Panel from 'wonderbly-components/lib/Panel';
import TextField from 'wonderbly-components/lib/TextField';
import InlineLabel from 'wonderbly-components/lib/InlineLabel';

const Address = bootstrapWithAmazon(AmazonAddressBook);
const Wallet = bootstrapWithAmazon(WalletWidget);

const AmazonWidget = ({
  widgetType,
  fetchingShippingMethods,
  isOptInChecked,
  marketingOptInLabel,
  handleOptInClick,
  children,
  isHidden,
  isSubmitting,
  handleWalletError,
  ...props
}) => {
  const {
    amazonAuthentication,
    handleAddressSelection,
    merchantId,
  } = props;

  if (isHidden) {
    return null;
  }

  return (
    <section className={cx('amazon-widget', {
      [`amazon-widget__${widgetType}`]: widgetType
    })}>
      {widgetType !== 'custom' &&
        <Panel border="shadow">
          {widgetType === 'address' &&
            <Fragment>
              <Address
                {...props}
                amazonScriptLoaded={!!amazonAuthentication}
                onAddressSelect={handleAddressSelection}
                sellerId={merchantId}
                // Must pass in an empty object and not a falsey value because the lib checks for an object and only then overrides, which is what we want.
                // We want to override the base styling that the lib has hardcoded, and use our own from the scss file.
                style={{ border: 'none' }}
              />
              {isOptInChecked !== null && marketingOptInLabel &&
                <div className="field-container checkbox_input checkbox_input--marketing_opt_in">
                  <TextField
                    type="checkbox"
                    name="marketing_opt_in"
                    id="checkbox_input--marketing_opt_in"
                    checked={isOptInChecked}
                    onClick={handleOptInClick}
                  />
                  <InlineLabel htmlFor="checkbox_input--marketing_opt_in">{marketingOptInLabel}</InlineLabel>
                </div>
              }
            </Fragment>
          }
          {widgetType === 'wallet' &&
            <Wallet
              {...props}
              amazonScriptLoaded={!!amazonAuthentication}
              sellerId={merchantId}
              style={{ }}
              onError={handleWalletError}
            />
          }
        </Panel>
      }
      {widgetType === 'custom' && children}
      {(fetchingShippingMethods || isSubmitting) && <div className="loading loading--absolute amazon-widget--loading"/>}
    </section>
  );
};

AmazonWidget.propTypes = {
  widgetType: PropTypes.oneOf(['address', 'wallet', 'custom']).isRequired,
  handleAddressSelection: PropTypes.func.isRequired,
  handleOptInClick: PropTypes.func.isRequired,
  handleWalletError: PropTypes.func.isRequired,
  marketingOptInLabel: PropTypes.string,
  merchantId: PropTypes.string,
  orderReference: PropTypes.string,
  widgetUrl: PropTypes.string,
  fetchingShippingMethods: PropTypes.bool,
  isHidden: PropTypes.bool,
  isSandbox: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  amazonAuthentication: PropTypes.object,
  amazonSettings: PropTypes.object,
  isOptInChecked: PropTypes.oneOf([null, true, false]),
  children: PropTypes.node,
};

export default AmazonWidget;



// WEBPACK FOOTER //
// ./src/client/js/view/components/PaymentMethods/Amazon/AmazonWidget/AmazonWidget.js